export default __webpack_public_path__ + "static/media/hue.8a6aa260.png";